"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function qwark(initialValue) {
    let value = initialValue;
    const listeners = new Set();
    return () => {
        const [state, setState] = (0, react_1.useState)(value);
        const handleSetState = (0, react_1.useCallback)((nextState) => {
            if (nextState instanceof Function) {
                value = nextState(value);
            }
            else {
                value = nextState;
            }
            listeners.forEach((listener) => listener(value));
        }, []);
        (0, react_1.useEffect)(() => {
            listeners.add(setState);
            return () => {
                listeners.delete(setState);
            };
        }, []);
        return [state, handleSetState];
    };
}
exports.default = qwark;
